/* Shared product imagery and Shopify variant mapping. */
(() => {
  const gallery = file => window.KM.asset('/assets/collection/gallery/' + file + '.webp');
  // The rear is shared by both numeral variants. Missing generation jobs stay out of the public gallery.
  const pendingBotan = new Set();
  const botanStudio = color => {
    const views = ['east-angle','east-front','east-back','west-angle','west-front','west-back'];
    const available = views.filter(view => !pendingBotan.has(color + '-' + (view === 'west-back' ? 'east-back' : view)));
    return {
      images: available.map(view => window.KM.asset('/assets/collection/botan-studio/' + color + '-' + (view === 'west-back' ? 'east-back' : view) + '.webp')),
      imageViews: available,
      imageWidths: available.map(view => ['silver-east-back','silver-west-front','gold-west-angle'].includes(color + '-' + (view === 'west-back' ? 'east-back' : view)) ? 1254 : 1600)
    };
  };
  const studioSeries = (model, color) => {
    const imageViews = ['east-angle','east-front','east-side','west-angle','west-front','west-side'];
    return {
      images: imageViews.map(view => window.KM.asset(`/assets/collection/product-studio/${model}-${color}-${view}.webp`)),
      imageViews,
      imageWidths: imageViews.map(() => 1254)
    };
  };
  window.WatchImagery = {
    label(finish, index) {
      const view = finish.imageViews?.[index];
      if (!view) return '';
      return (finish.fixedDial ? '' : (view.startsWith('west') ? 'Westliche Ziffern' : 'Arabische Ziffern') + ' · ') +
        (view.endsWith('angle') ? 'Schrägansicht' : view.endsWith('front') ? 'Frontansicht' : view.endsWith('side') ? 'Seitenansicht' : 'Glasboden');
    },
    set(image, finish, index, sizes) {
      const url = finish.images[index];
      if (finish.imageViews) {
        image.sizes = sizes;
        image.srcset = window.KM.imageVariant(url, '-800') + ' 800w, ' + url + ' ' + (finish.imageWidths?.[index] || 1600) + 'w';
      } else { image.removeAttribute('srcset'); image.removeAttribute('sizes'); }
      image.src = url;
    },
    dialFrame(finish, dial, current = 0) {
      if (!finish.imageViews || !dial) return current;
      const side = finish.imageViews[current]?.split('-')[1] || 'angle';
      const numeral = dial === 'Westliche Ziffern' ? 'west' : 'east';
      const exact = finish.imageViews.indexOf(numeral + '-' + side);
      return exact >= 0 ? exact : Math.max(0, finish.imageViews.findIndex(view => view.startsWith(numeral)));
    },
    thumb(url) { return window.KM.imageVariant(url, '-thumb'); }
  };
  window.WatchCatalogue = {
    botan: {name:'Botan', gender:'Herren', handle:'kurdistana-min-luxury-series-automatik', finishes:[
      {name:'Roségold', ...botanStudio('rose'), variant:'57455019589963'},
      {name:'Schwarz', ...botanStudio('black'), variant:'57455019622731'},
      {name:'Silber', ...botanStudio('silver'), variant:'57455019655499'},
      {name:'Gold', ...botanStudio('gold'), variant:'57455019688267', visualization:true}
    ]},
    roj: {name:'Roj', gender:'Damen', handle:'kurdistana-min-roj-33mm-frauen-uhr', finishes:[
      {name:'Roségold', ...studioSeries('roj','rose'), variant:'58228912619851'},
      {name:'Silber', ...studioSeries('roj','silver'), variant:'58228912619851', visualization:true}
    ]},
    heval:{name:'Heval',gender:'Herren',handle:'kurdistana-min-luxus-series-heval',finishes:[
      {name:'Schwarz',...studioSeries('heval','black'),variant:'58037663859019'}
    ]},
    welat:{name:'Welat',gender:'Herren',handle:'kurdistana-min-luxus-series-welat',finishes:[
      {name:'Silber',...studioSeries('welat','silver'),variant:'58037659468107'}
    ]},
    amedspor:{name:'Amedspor',gender:'Herren',handle:'amedspor-uhr-automatic-sampyion',finishes:[
      {name:'Silber',images:['angle','front','side'].map(view => window.KM.asset(`/assets/collection/product-studio/amedspor-silver-${view}.webp`)), imageViews:['original-angle','original-front','original-side'], imageWidths:[1254,1254,1254],fixedDial:true,variant:'58481963073867'}
    ]}
  };
})();
